import { ILLFAttributeRegistrator, ILLFAttributeRenderer, PriorityRegistrator } from "@multiweb/customization";

/**
 * Registrátor, který umožnuje jednotlivým rendererům přidat priority.
 *
 * Priorit se využívá při hledání, který renderer může zobrazit daný element (v metodě `findRenderer`).
 * Vracíme renderer s největší prioritou, který splňuje podmínku `canRender`. Pokud žádný ze zaregistrovaných rendererů
 * neumí element zobrazit, použije se defaultní renderer.
 */
export class LLFAttributeRegistrator extends PriorityRegistrator<ILLFAttributeRenderer> implements ILLFAttributeRegistrator {
    public findRenderer(element: HTMLElement): ILLFAttributeRenderer {
        return this._registeredRenderers.get(this._getRendererKeyByElement(element)) ?? this._defaultRenderer;
    }

    /**
     * Získá klíč rendereru pro daný element.
     *
     * @param element Element atributu z DOMu.
     * @returns Klíč nalezeného rendereru. Pokud existuje více rendererů, které umí daný atribut vykreslit,
     * rozhoduje jejich priorita zadaná v inicializaci Singleton rendereru při registraci.
     */
    private _getRendererKeyByElement(element: HTMLElement): string {
        for (const { itemKey } of this._renderersPriorities) {
            const renderer = this._registeredRenderers.get(itemKey);
            if (!renderer || !renderer.canRender(element)) {
                continue;
            }
            return itemKey;
        }
        return this._defaultRenderer.key;
    }
}
